'use no memo';

import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import ImportCsv from '@/features/import-csv';
import type { ExportApiUrl } from '@/features/import-csv/types';
import { ImportCsvSearchSchema } from '@/features/import-csv/zod-schemas';
import { stacktraceNS, useTranslation } from '@/lib/i18n';

import useValueTableRows from './-hooks/useValueTableRows';

/**
 * Value 一覧 CSV 一括取り込み画面 (/values/import-csv)。
 *
 * Issue (`/issues/import-csv`) を踏襲した薄いラッパー。
 * 共通 `ImportCsv` feature に Value 用の export URL / hook を渡すだけ。
 *
 * 文言は stacktraceNS の `values.importCsv` 配下を参照する (6 言語対応済み)。
 */
const ValueImportCsv = () => {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const { t } = useTranslation(stacktraceNS, {
    keyPrefix: 'values.importCsv',
  });

  const exportApiUrl: ExportApiUrl = '/v2/product-central/values/csv';

  return (
    <ImportCsv
      baseLink="/values/import-csv"
      baseTitle={t('pageTitle')}
      exportApiUrl={exportApiUrl}
      exportFilename="value-list"
      templateMessage={{
        templateTitle: t('templateMessage.templateTitle'),
        updateExisting: t('templateMessage.updateExisting'),
        completeLinkButton: t('templateMessage.completeLinkButton'),
      }}
      completeLinkUrl="/values"
      unit={t('unit')}
      search={search}
      navigate={navigate}
      useTableRows={useValueTableRows}
    />
  );
};

export const Route = createFileRoute('/_stacktrace/values/import-csv')({
  validateSearch: zodValidator(ImportCsvSearchSchema),
  component: ValueImportCsv,
});
